import LanguageSetting from "@/view/addin/settings/language/index";
import {
  Button,
  MessageBar,
  MessageBarActions,
  MessageBarBody,
  MessageBarGroup,
  MessageBarIntent
} from "@fluentui/react-components";
import { DismissRegular } from "@fluentui/react-icons";
import React from "react";
import { IMessageItem } from "./Models";
import { SettingBaseWrapper } from "./Styles";
import AssistantOrgSetting from "./assistant-org";
import { CategoriesSetting } from "./categories";
import { DatetimeSetting } from "./date-time";
import { HelpSetting } from "./help";
import { LocationSetting } from "./locations";
import { VERSION } from "@/version";
const intents: MessageBarIntent[] = ["info", "warning", "error", "success"];

const Setting = () => {
  const [messages, setMessages] = React.useState<IMessageItem[]>([]);
  const addMessage = (
    payload : IMessageItem
  ) => {
    const newMessage = {
      id: payload.id,
      type: payload.type,
      content:  payload.content,
      autoClose:  payload.autoClose,
    };

    setMessages((s) => [newMessage, ...s]);

    if ( payload.autoClose) {
      setTimeout(() => {
        dismissMessage( payload.id);
      },  payload.autoClose);
    }
  };
  // const clearMessages = () => setMessages([]);
  const dismissMessage = (messageId: string) => {
    setMessages((s) => s.filter((entry) => entry.id !== messageId));
  };
  return (
    <SettingBaseWrapper className="SettingBaseWrapper">
      <MessageBarGroup>
        {messages.map(({ type, id, content }) => (
          <MessageBar
            key={`${type}-${id}`}
            intent={intents.find((a) => a === type)}
            style={{
              marginBottom :2
            }}
          >
            <MessageBarBody>{content}</MessageBarBody>
            <MessageBarActions
              containerAction={
                <Button
                  onClick={() => dismissMessage(id)}
                  aria-label="dismiss"
                  appearance="transparent"
                  icon={<DismissRegular />}
                />
              }
            />
          </MessageBar>
        ))}
      </MessageBarGroup>
      <LanguageSetting addMessage={addMessage} />
      <AssistantOrgSetting assistantEnable={false} />
      <DatetimeSetting addMessage={addMessage} />
      <LocationSetting addMessage={addMessage} />
      <CategoriesSetting addMessage={addMessage} />
      <HelpSetting />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <p style={{ fontStyle: "italic", fontWeight: 400 }}>
          @Outlook Add-in Version. &nbsp;
          <small>
            <b>{VERSION}</b>
          </small>
        </p>
      </div>
    </SettingBaseWrapper>
  );
};

export default Setting;
